import { useEffect, useState } from 'react';

/**
 * @param value the value that is returned with a delay
 * @param delay  the delay in milliseconds
 *
 * @returns the value of the parameter with the specified delay
 */
function useDebounce<T>(value: T, delay = 500): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => clearTimeout(handler);
  }, [delay, value]);

  return debouncedValue;
}

export { useDebounce };
